var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0013 1.33203H6.66797L2.66797 5.33203V13.332C2.66797 14.0654 3.26797 14.6654 4.0013 14.6654H12.0013C12.7346 14.6654 13.3346 14.0654 13.3346 13.332V2.66536C13.3346 1.93203 12.7346 1.33203 12.0013 1.33203ZM12.0013 2.66536V13.332H4.0013V5.88536L7.2213 2.66536H12.0013Z",
    fill: "#4B4B4B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6654 8.66667L7.9987 11.3333L5.33203 8.66667L6.27203 7.72667L7.33203 8.78V6.01333L8.66536 6V8.78L9.72536 7.72L10.6654 8.66667Z",
    fill: "#4B4B4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/downloadIcon.ff6d96755fb5c2830eae51c147d1e554.svg";
export { ForwardRef as ReactComponent };